import { DeferTimerMessage } from 'src/components/NotificationsDeferPopup/types';

const allowedOrigins = [
  'https://assess.eiq.ai',
  'https://phoenix-onboard.elevatelimited.com',
  'https://eiq-assess.staging.elevatelimited.com',
  'https://eiq-assess-dev2.dev.elevatelimited.com',
  'https://eiq-assess.dev.elevatelimited.com'
];
/* eslint-disable no-restricted-globals */
self.addEventListener("message", event => {
  if(!allowedOrigins.includes(event.origin))
  {
    return;
  }
  let countdownMillisLeft = event.data?.value ? event.data.value * 1000 : 0;

  const clearTimeoutAndInterval = () => {
    if (self.countdownInterval) {
      clearInterval(self.countdownInterval);
    }
    if (self.countdownTimeout) {
      clearTimeout(self.countdownTimeout);
    }
  }

  switch (event.data.type) {
    case DeferTimerMessage.StartCountdown:
      postMessage({
        type: DeferTimerMessage.ReturnCountdownValue,
        value: countdownMillisLeft / 1000,
      });

      clearTimeoutAndInterval();

      self.countdownInterval = setInterval(() => {
        countdownMillisLeft -= 1000;
        postMessage({
          type: DeferTimerMessage.ReturnCountdownValue,
          value: countdownMillisLeft / 1000
        });
      }, 1000);

      self.countdownTimeout = setTimeout(() => {
        postMessage({
          type: DeferTimerMessage.StopCountdown
        });
        clearInterval(self.countdownInterval);
      }, countdownMillisLeft);

      break;
    case DeferTimerMessage.ClearCountdown:
      clearTimeoutAndInterval();
      break;
    default:
      break;
  }
});
